﻿import * as React from 'react';
import { Col, Panel } from 'react-bootstrap';
import { formatDate, Translate } from '../../../../../../shared/LanguageService';

type DigitalStylingOrderInfoLabels = {
    title: string;
    orderStatus: string;
    completedBy: string;
};

type DigitalStylingOrderInfoProps = {
    labels: DigitalStylingOrderInfoLabels;
    orderStatus: string;
    completedBy: string;
};

type ExternalProps = {
    completedBy: string | null;
    orderStatus: {
        displayName: string;
        value: number;
    };
};

function DigitalStylingOrderInfo({
    labels,
    completedBy,
    orderStatus
}: DigitalStylingOrderInfoProps) {
    return (
        <Col md={12} lg={6}>
            <Panel>
                <Panel.Heading>
                    <h3 className="panel-title">{labels.title}</h3>
                </Panel.Heading>
                <Panel.Body>
                    <dl>
                        <dt>{labels.orderStatus}</dt>
                        <dd>{orderStatus}</dd>
                        <dt>{labels.completedBy}</dt>
                        <dd>
                            {completedBy ? (
                                formatDate(new Date(completedBy), 'yyyy-MM-dd HH:mm')
                            ) : (
                                <span dangerouslySetInnerHTML={{ __html: '&mdash;' }} />
                            )}
                        </dd>
                    </dl>
                </Panel.Body>
            </Panel>
        </Col>
    );
}

export default function TranslatedDigitalStylingOrderInfo({
    orderStatus,
    completedBy
}: ExternalProps) {
    return (
        <DigitalStylingOrderInfo
            orderStatus={Translate(orderStatus.displayName)}
            completedBy={completedBy}
            labels={{
                title: Translate('order-type/digital-styling'),
                orderStatus: Translate('view-order/basic-order-info/titles/styling-status'),
                completedBy: Translate('view-order/basic-order-info/titles/performed-time')
            }}
        />
    );
}
